import { Store } from '@revenuemarket/ui/Icon';

export const taxInvoice = {
  title: '간편 매출 연결',
  headerDescription:
    '발생하는 모든 매출채권을 종류에 따라 아래 두 가지 방식으로 연결해주세요. 매출채권을 빠짐없이 등록할수록 정확한 한도 산정 및 유연한 장래매출채권 양도가 가능합니다.',
  description: 'B2C · 해외 매출',
  uploadTitle: '최근 업로드한 파일',
  uploadIcon: <Store />,
};
